import { setQueriesDataFromKey } from '@pba/react-query';
import { useQueryClient } from '#react-query';
import { type MessagesInfiniteQueryData, getMessagesInfiniteQueryKey } from '../use-get-messages';

export const useDeleteChatroomMessageInCache = () => {
  const queryClient = useQueryClient();

  return ({ chatroomId, messageId }: { chatroomId: string; messageId: string }) => {
    setQueriesDataFromKey<MessagesInfiniteQueryData>(
      queryClient,
      getMessagesInfiniteQueryKey({ filter: { chatroomId } }),
      (data) => {
        if (!data) {
          return data;
        }

        return {
          pageParams: data.pageParams,
          pages: data.pages.map((page) => page.filter((message) => message._id !== messageId)),
        };
      },
    );
  };
};
